import { Injectable, signal } from '@angular/core';

export type SecurityLockReason = 'OFFLINE_DATA_TAMPER_DETECTED';

export interface SecurityLockState {
  reason: SecurityLockReason;
  message: string;
  createdAt: string;
  details?: Record<string, unknown>;
}

const SECURITY_LOCK_KEY = 'tops.security.lock';

@Injectable({ providedIn: 'root' })
export class SecurityLockService {
  private readonly lockSignal = signal<SecurityLockState | null>(this.readLock());

  readonly lock = this.lockSignal.asReadonly();

  get currentLock(): SecurityLockState | null {
    return this.lockSignal();
  }

  isLocked(): boolean {
    return !!this.lockSignal();
  }

  lockApp(reason: SecurityLockReason, message: string, details?: Record<string, unknown>): SecurityLockState {
    const state: SecurityLockState = {
      reason,
      message,
      createdAt: new Date().toISOString(),
      details,
    };
    this.lockSignal.set(state);
    localStorage.setItem(SECURITY_LOCK_KEY, JSON.stringify(state));
    return state;
  }

  clearLock(): void {
    this.lockSignal.set(null);
    localStorage.removeItem(SECURITY_LOCK_KEY);
  }

  private readLock(): SecurityLockState | null {
    try {
      const rawLock = localStorage.getItem(SECURITY_LOCK_KEY);
      return rawLock ? JSON.parse(rawLock) as SecurityLockState : null;
    } catch {
      return null;
    }
  }
}